package com.fireavert.properties.add_new_property_admin.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class ResendPropertyAdminInviteRequest(val propertyAdminId: String)